import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export const Layout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const routeTitles: Record<string, string> = {
    '/app/dashboard': 'Dashboard',
    '/app/search': 'Search Intelligence',
    '/app/reports': 'My Reports',
    '/app/subscriptions': 'Subscription & Plans',
    '/app/payments': 'Payment History',
    '/app/api-keys': 'API Keys Management',
    '/app/referrals': 'Referral Program',
    '/app/profile': 'My Profile',
    '/app/admin/users': 'User Management',
    '/app/admin/organizations': 'Organizations',
    '/app/admin/api-management': 'API Management',
    '/app/admin/ai-providers': 'AI Providers',
    '/app/admin/ai-summary-configs': 'AI Summary Configs',
    '/app/admin/api-content-transformer': 'Content Transformer',
    '/app/admin/api-responses': 'API Responses',
    '/app/admin/api-logs': 'API Logs',
    '/app/admin/report-templates': 'Report Templates',
    '/app/admin/all-searches': 'All Searches Report',
    '/app/admin/session-manager': 'Session Manager',
    '/app/admin/monitoring': 'System Monitoring',
    '/app/admin/subscription-plans': 'Subscription Plans Admin',
    '/app/admin/payments': 'Payments Admin',
    '/app/admin/offline-payments': 'Offline Payments',
    '/app/admin/intcoins-report': 'IntCoins Report',
    '/app/admin/osint-test': 'OSINT Test Lab',
    '/app/admin/universal-osint': 'Universal OSINT',
    '/app/admin/search-parameters': 'Search Parameters',
    '/app/admin/law-enforcement': 'Law Enforcement Verifications',
  };

  const getPageTitle = () => {
    if (routeTitles[location.pathname]) {
      return routeTitles[location.pathname];
    }
    if (location.pathname.startsWith('/app/search/') && location.pathname.endsWith('/report')) {
      return 'Search Intelligence Report';
    }
    // Clean fallback from path
    const segment = location.pathname.split('/').filter(Boolean).pop();
    if (segment) {
      return segment.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
    }
    return 'IntFinder Intelligence';
  };

  const pageTitle = getPageTitle();

  // Main content margin
  const mainMargin = collapsed ? 'md:ml-20' : 'md:ml-64';

  return (
    <div className="min-h-screen flex bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 overflow-x-hidden">
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <Sidebar
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((c) => !c)}
          mobileOpen={false}
          onCloseMobile={() => {}}
        />
      </div>
      {/* Mobile drawer */}
      {mobileOpen && (
        <Sidebar
          collapsed={false}
          onToggleCollapse={() => {}}
          mobileOpen={true}
          onCloseMobile={() => setMobileOpen(false)}
        />
      )}
      <div className={`flex-1 flex flex-col min-h-screen transition-all duration-300 w-full overflow-x-hidden ${mainMargin}`}>
        <Header
          title={pageTitle}
          collapsed={collapsed}
          onMenuClick={() => {
            if (window.innerWidth < 768) setMobileOpen((open) => !open);
            else setCollapsed((c) => !c);
          }}
        />
        <main className="flex-1 p-3.5 sm:p-6 md:p-8 mt-16 bg-gray-50 dark:bg-gray-900 max-w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
